// extracted by mini-css-extract-plugin
export var dataCell = "_om-2";
export var dataRow = "_om-0";
export var headerRow = "_om-1";